import React from 'react';
import PropTypes from 'prop-types';

import { DropdownButton, DropdownMenuItem } from 'shared/Buttons';
import { DownArrowIcon, UpArrowIcon } from 'shared/Miscellaneous/Icons';
import { querySortBy, querySortDir } from 'productList/utils';

const sortOptions = [
  {
    label: 'Relevance',
    // eslint-disable-next-line no-underscore-dangle
    value: querySortBy._score
  },
  {
    label: 'Name',
    value: querySortBy.name
  },
  {
    label: 'Category',
    value: querySortBy.category
  },
  {
    label: 'Last Update',
    value: querySortBy.updated
  },
  {
    label: 'Published',
    value: querySortBy.published
  }
];

const sortMap = {}; // create map from options e.g. { modified: 'Last Update' }
sortOptions.forEach(({ label, value }) => {
  sortMap[value] = label;
});

const SortIndicator = ({ sortDir }) =>
  sortDir === querySortDir.descending ? <DownArrowIcon height={15} /> : <UpArrowIcon height={15} />;

SortIndicator.propTypes = {
  sortDir: PropTypes.string
};

const SortControls = ({ setSortBy, sortBy, sortDir }) => (
  <DropdownButton
    id="grid-sort"
    title={sortBy ? sortMap[sortBy] : sortOptions[0].label}
    icon={<SortIndicator {...{ sortDir }} />}
  >
    {sortOptions.map(({ label, value }, index) => (
      <DropdownMenuItem
        key={`sort-${label}`}
        eventKey={index}
        onClick={() => setSortBy(value)}
        isSort
      >
        {' '}
        {label}
        {value && value === sortBy && <SortIndicator {...{ sortDir }} />}
      </DropdownMenuItem>
    ))}
  </DropdownButton>
);

SortControls.propTypes = {
  setSortBy: PropTypes.func.isRequired,
  sortBy: PropTypes.string,
  sortDir: PropTypes.number
};

export default SortControls;
